/*************************************************/
/* VUE                                           */
/*************************************************/

import { createApp,h } from 'vue';
import {createRouter,createWebHistory} from "vue-router";
import Articles from './vue/articles.vue';


const articlesAppSelector = "#articlesApp";
if (document.querySelector(articlesAppSelector) != null) {
    const articlesNodeId = document.querySelector(articlesAppSelector).dataset.articlesNodeId;
    const pageSize = document.querySelector(articlesAppSelector).dataset.pagesize;
    const isCasesPage = document.querySelector(articlesAppSelector).dataset.cases;
    const sortorder = document.querySelector(articlesAppSelector).dataset.sortOrder;

    const router = createRouter({
        history: createWebHistory(),
        routes: [{path : window.location.pathname,component:Articles}]
    });

    const seedData = {articlesNodeId:articlesNodeId,pageSize:pageSize,isCasesPage:isCasesPage,sortorder:sortorder};

    const articlesApp = createApp({
        data() {return seedData},
        render: ()=>h(Articles)
    },seedData);

    articlesApp.use(router);
    router.isReady().then(() => articlesApp.mount(articlesAppSelector));
}